import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { ContactType_Enum, PersonStatus_Enum } from '@weave/schema-gen-ts/dist/shared/persons/v3/enums.pb';
import { PersonsV3, PersonTypes } from '@frontend/api-person';
import { demoDataUtils } from '../utils/demo-data-utils';

export const getRandomPersonList = {};

export class MockPersons {
  persons: Person[] = [];

  constructor(count: number) {
    this.generateRandomPersons(count);
  }

  generateRandomPersons(count: number): Person[] {
    const userNamesList = demoDataUtils.generateRandomUserNames(count);
    // generate list of household ids to group max 3 persons in a household
    const householdIds = Array.from({ length: count / 3 }).map(() => demoDataUtils.generateRandomUUID());

    this.persons = userNamesList.map<Person>(({ firstName, lastName }, index) => {
      const pmId = `${demoDataUtils.generateRandomInt(1000, 9999)}`;
      const sourceId = demoDataUtils.generateRandomUUID();
      const personId = demoDataUtils.generateRandomUUID();
      const contactInfoId = demoDataUtils.generateRandomUUID();
      const householdId = householdIds[index % householdIds.length];

      const person: Person = {
        firstName,
        lastName,
        address: {
          city: demoDataUtils.getRandomElement(['New York', 'Los Angeles', 'Chicago']),
          state: demoDataUtils.getRandomElement(['NY', 'CA', 'IL']),
          street: demoDataUtils.getRandomElement(['123 Main St', '456 Elm St', '789 Oak St']),
          postalCode: demoDataUtils.getRandomElement(['10001', '90001', '60601']),
        },
        sourceTenantId: sourceId,
        personPmid: pmId,
        personDisplayPmid: pmId,
        personId,
        status: PersonStatus_Enum.ACTIVE,
        householdId,
        householdPmid: `pm_${householdId}`,
        isGuardian: Math.random() < 0.2,
        sourceId,
        contactInfo: [
          {
            sourceId,
            contactInfoId,
            contactInfoPmid: `email_${pmId}`,
            personId,
            type: ContactType_Enum.EMAIL,
            destination: `${firstName.toLowerCase()}.${lastName.toLowerCase()}@example.com`,
            priority: 0,
          },
          {
            sourceId,
            contactInfoId,
            contactInfoPmid: `home_phone_${pmId}`,
            personId,
            type: ContactType_Enum.PHONE_HOME,
            destination: demoDataUtils.generateRandomPhoneNumber(),
            priority: 0,
          },
          {
            sourceId,
            contactInfoId,
            contactInfoPmid: `office_phone_${pmId}`,
            personId,
            type: ContactType_Enum.PHONE_WORK,
            destination: demoDataUtils.generateRandomPhoneNumber(),
            priority: 0,
          },
        ],
        birthdate: demoDataUtils.generateRandomBirthDate(),
        createdAt: demoDataUtils.generateRandomDate(),
        modifiedAt: demoDataUtils.generateRandomDate(),
        gender: demoDataUtils.generateRandomGender(),
      };

      return person;
    });

    return this.persons;
  }

  getFilteredPersons(filters: { personId?: string; householdId?: string }): Person[] {
    return this.persons.filter((person) => {
      if (filters.personId && person.personId !== filters.personId) {
        return false;
      }
      if (filters.householdId && person.householdId !== filters.householdId) {
        return false;
      }
      return true;
    });
  }

  getPersonExtended(filters: { personId?: string; householdId?: string }): PersonTypes.Person {
    return {
      ...PersonsV3.PersonHelpers.convertPersonV3ToPerson(this.getFilteredPersons(filters)[0]),
      SourceType: PersonTypes.PersonSourceType.Integration,
    };
  }

  getPersonV3(filters: { personId?: string; householdId?: string }): Person {
    return this.getFilteredPersons(filters)[0];
  }
}
